import { Component, input } from '@angular/core';
import { AuthStatus } from '../../core/auth/token.service';

@Component({
  selector: 'app-error',
  standalone: true,
  templateUrl: './error.component.html',
  styleUrl: './error.component.scss',
})
export class ErrorComponent {
  readonly errorType    = input<AuthStatus>('no-mac');
  readonly errorMessage = input('Une erreur est survenue.');

  get icon(): string {
    switch (this.errorType()) {
      case 'hardware-inactive': return '🔒';
      case 'invalid-mac':       return '⚠️';
      case 'error':             return '🔌';
      case 'no-mac':
      default:                  return '❌';
    }
  }

  get title(): string {
    switch (this.errorType()) {
      case 'hardware-inactive': return 'Borne désactivée';
      case 'invalid-mac':       return 'Borne non reconnue';
      case 'error':             return 'Erreur de connexion';
      case 'no-mac':
      default:                  return 'Configuration manquante';
    }
  }
}
